var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.27647 12 12 9.28235 12 6C12 2.72353 9.27059 0 5.99412 0C2.71176 0 0 2.72353 0 6C0 9.28235 2.71765 12 6 12ZM6 11C3.22353 11 1.00588 8.77647 1.00588 6C1.00588 3.22941 3.21765 1 5.99412 1C8.76471 1 10.9941 3.22941 11 6C11.0059 8.77647 8.77059 11 6 11ZM5.94706 3.90588C6.37647 3.90588 6.71176 3.56471 6.71176 3.14118C6.71176 2.71176 6.37647 2.37059 5.94706 2.37059C5.51765 2.37059 5.18235 2.71176 5.18235 3.14118C5.18235 3.56471 5.51765 3.90588 5.94706 3.90588ZM4.96471 9.23529C4.72941 9.23529 4.54118 9.06471 4.54118 8.82353C4.54118 8.59412 4.72941 8.41176 4.96471 8.41176H5.7V5.71176H5.06471C4.82941 5.71176 4.64118 5.54118 4.64118 5.3C4.64118 5.07059 4.82941 4.88824 5.06471 4.88824H6.17647C6.47059 4.88824 6.63529 5.1 6.63529 5.41765V8.41176H7.36471C7.60588 8.41176 7.79412 8.59412 7.79412 8.82353C7.79412 9.06471 7.60588 9.23529 7.36471 9.23529H4.96471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.3520614e538e09607f73df99e08fec99.svg";
export { ForwardRef as ReactComponent };